import { createClient } from "@supabase/supabase-js";

// The key is deliberately publishable (and already used by the legacy client).
// Environment variables take priority so production can rotate it without a code change.
const url = import.meta.env.VITE_SUPABASE_URL?.trim() || "https://vigtdmkavkmjbpgkeisj.supabase.co";
const publishableKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() || "sb_publishable_7nv0xQoolwqRC39Htgde6Q_8ctgHD1c";

export const supabase = url && publishableKey
  ? createClient(url, publishableKey, { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } })
  : null;

export const hasSupabaseConfig = Boolean(supabase);
